import {
  ROLE_PRINCIPAL_INVESTIGATOR,
  ROLE_STUDY_MANAGER,
  ROLE_SUB_INVESTIGATOR
} from '../../../../../../../constants/userRoles';
import { caseInsensitiveStringEquals } from '../../../../../../../services/string';

export function isGroupAssignAvailableForRole({ type }, role) {
  if (caseInsensitiveStringEquals(type, 'Other')) {
    return true;
  } else if (role === ROLE_STUDY_MANAGER) {
    return caseInsensitiveStringEquals(type, 'SM');
  } else if (role === ROLE_PRINCIPAL_INVESTIGATOR || role === ROLE_SUB_INVESTIGATOR) {
    return caseInsensitiveStringEquals(type, 'Investigator');
  }
  return false;
}
